import { SalaryValues } from "../../features/employment/employmentApi";

const filterFalsySalaryParameters = (
  queryParameters: Record<string, string>,
): Record<string, Record<string, string|SalaryValues>> => {
  return Object.keys(queryParameters).reduce<Record<string, Record<string, string|SalaryValues>>>(
    (acc, key) => {
        const keypieces = key.split(" ");
        if (keypieces.length === 1) {
          if (queryParameters[key]) {
              acc['salary'][key] = queryParameters[key];
          }
        } else {
            if (queryParameters[key]) {
                const zoned = acc['zonedSalary'] as Record<string, SalaryValues>;
                const realSalaryKey: keyof SalaryValues = keypieces[1] as keyof SalaryValues;
                if (!zoned[keypieces[0]]) {
                    zoned[keypieces[0]] = {};
                }
                zoned[keypieces[0]][realSalaryKey] = queryParameters[key];
            }
        }
      return acc;
    },
    {salary:{}, zonedSalary:{}},
  );
};

export default filterFalsySalaryParameters;
